import { alias, AliasedConstructor } from '../../rest/decorators/alias'
import {
  Serialisable,
  SerialisationConfig,
} from '../../rest/utilities/serialisable'

export class Owner extends Serialisable {
  public static override serialisationConfig: SerialisationConfig =
    new SerialisationConfig(() => new Owner())

  @alias('id')
  id!: number
  @alias('first_name')
  firstName!: string
  @alias('last_name')
  lastName!: string
  @alias('email')
  email!: string
  @alias('morph_type')
  morphType!: string

  constructor() {
    super((Owner as unknown as AliasedConstructor)._alias)
  }

  get name(): string {
    if (this.firstName != null && this.lastName != null) {
      return `${this.firstName} ${this.lastName}`
    } else if (this.firstName != null) {
      return this.firstName
    } else if (this.lastName != null) {
      return this.lastName
    } else {
      return 'Owner'
    }
  }
}
